
      import { GeoWiki } from '../src/geo-wiki';
      import { FolkWeather } from '../src/folk-weather';
      import '@folkjs/labs/standalone/folk-shape';
      import { FolkMap } from '@folkjs/labs/standalone/folk-map';
      import { FolkCluster } from '@folkjs/labs/standalone/folk-proximity';
      import '@folkjs/labs/standalone/folk-event-propagator';

      FolkCluster.registerElement({
        constructor: FolkMap,
        events: {
          recenter: (e) => ({
            lat: e.target.coordinates.lat,
            lng: e.target.coordinates.lng,
          }),
        },
        onAdd: (element) => ({
          lat: element.coordinates.lat,
          lng: element.coordinates.lng,
        }),
      });

      FolkCluster.registerElement({
        constructor: FolkWeather,
        onUpdate(element, data, changes) {
          const lat = data.get('lat');
          const lng = data.get('lng');

          if (lat && lng) {
            element.coordinates = [lat, lng];
          }
        },
      });

      FolkCluster.registerElement({
        constructor: GeoWiki,
        onUpdate(element, data, changes) {
          const lat = data.get('lat');
          const lng = data.get('lng');

          if (lat && lng) {
            element.coordinates = [lat, lng];
          }
        },
      });
    